import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
<svg  width={props.width || "20"}
    height={props.height || "20"} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_219_2241)">
<path d="M7.41177 12.3529C3.32486 12.3529 0 15.6778 0 19.7647C0 23.8516 3.32486 27.1765 7.41177 27.1765C11.4987 27.1765 14.8235 23.8516 14.8235 19.7647C14.8235 15.6778 11.4986 12.3529 7.41177 12.3529ZM7.41177 23.0588C5.59539 23.0588 4.11765 21.5811 4.11765 19.7647C4.11765 17.9483 5.59539 16.4706 7.41177 16.4706C9.22814 16.4706 10.7059 17.9483 10.7059 19.7647C10.7059 21.5811 9.22814 23.0588 7.41177 23.0588Z" fill="#556987"/>
<path d="M4.94129 11.0484C6.55047 10.5916 8.27296 10.5915 9.88247 11.0484C9.88247 10.7087 9.88247 3.99418 9.88247 3.99418C9.88247 2.24588 8.46012 0.823532 6.71182 0.823532H2.4707V2.47059H4.94129V11.0484Z" fill="#556987"/>
<path d="M23.0587 18.1176L25.2548 19.7647H27.9999V18.1176H25.8038L23.0587 16.0588C23.0587 15.6977 23.0587 12.6624 23.0587 12.3119C23.0587 10.0641 21.2299 8.23529 18.9821 8.23529H11.5293V9.88235H18.9821C20.3217 9.88235 21.4117 10.9723 21.4117 12.3119V12.3529H12.614C14.7333 13.8448 16.1864 16.2214 16.4326 18.9412H21.4117V20.6924C19.9925 21.0591 18.9411 22.3502 18.9411 23.8824C18.9411 25.6987 20.4188 27.1765 22.2352 27.1765C24.0516 27.1765 25.5293 25.6987 25.5293 23.8824C25.5293 22.3503 24.4779 21.0591 23.0587 20.6924C23.0587 19.9194 23.0587 18.8804 23.0587 18.1176Z" fill="#556987"/>
</g>
<defs>
<clipPath id="clip0_219_2241">
<rect width="28" height="28" fill="white"/>
</clipPath>
</defs>
</svg>
);

export default SvgComponent;
